import React from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import Union from '../assets/Union.svg';
import Orb from '../assets/Orb.svg';
import AIPrompt from '../assets/AIPrompt.svg';
import Impressions from '../assets/impressions.svg';
import HotTake from '../assets/hotTake.svg';
import ProfileContainer from '../assets/profileContainer.svg';
import PromptBox from '../assets/promptBox.svg';
import FeatureItem from '../assets/featureItem.png';
import GraphicTemplate from '../assets/graphicTemplate.png';
// import FollowersGained from '../assets/followersGained.svg';
import LegendGraphLeads from '../assets/legendGraphLeads.svg';
import GraphLeads from '../assets/graphLeads.svg';
import ProfileContainerFidget from '../assets/profileContainerfidget.svg';

export const CardsStats: React.FC = () => {
  return (
    <Container
      fluid
      className="d-flex justify-content-center"
      style={{ paddingTop: 80, paddingBottom: 200 }}
    >
      <Row className="w-100 justify-content-center">
        <Col xs={12} className="d-flex flex-column align-items-center" style={{ width: '80%' }}>
          <div
            style={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 500,
              fontSize: 50,
              lineHeight: '100%',
              letterSpacing: '-2%',
              textAlign: 'center' as const,
              color: '#FFFFFF',
            }}
          >
            The first complete LinkedIn tool
          </div>
          <div
            style={{
              marginTop: 20,
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: 20,
              lineHeight: '42px',
              textAlign: 'center' as const,
              color: '#FFFFFF6B',
              maxWidth: 800,
              marginBottom: 60,
            }}
          >
            Cero simplifies strategy and content creation for LinkedIn by utilizing AI, images and
            carousels to craft a personalized post with humanity-level quality
          </div>

          <Row className="w-100 justify-content-center g-2" style={{ marginTop: 32 }}>
            <Col xs={12} sm={6} lg={3}>
              <Card
                className="h-100 text-white"
                style={{
                  background: 'transparent',
                  borderRadius: 15,
                  overflow: 'hidden',
                  border: '1px solid transparent',
                  backgroundImage:
                    'linear-gradient(transparent, transparent), linear-gradient(180deg, rgba(255, 255, 255, 0.0576) 0%, rgba(255, 255, 255, 0.0512) 100%)',
                  backgroundOrigin: 'border-box',
                  backgroundClip: 'padding-box, border-box',
                  boxShadow: 'inset 0px 0px 8px 0px #FFFFFF0A',
                  paddingTop: 24,
                  paddingBottom: 50,
                }}
              >
                <Card.Body
                  className="d-flex flex-column align-items-center justify-content-between"
                  style={{ minHeight: 260, paddingBottom: 24 }}
                >
                  <div className="d-flex flex-column align-items-center" style={{ width: '100%' }}>
                    <div
                      style={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 500,
                        fontSize: 24,
                        lineHeight: '32px',
                        textAlign: 'center' as const,
                        color: '#FFFFFF',
                        width: '80%',
                      }}
                    >
                      Not a generic AI content tool
                    </div>
                    <div
                      style={{
                        marginTop: 12,
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: '24px',
                        textAlign: 'center' as const,
                        color: '#FFFFFF6B',
                        width: '100%',
                        marginBottom: 80,
                      }}
                    >
                      It’s like working with an expert content creator who knows your personal brand
                      inside out.
                    </div>
                  </div>

                  <div className="position-relative w-100" style={{ height: 140 }}>
                    <Image
                      src={Union}
                      alt="Union"
                      className="position-absolute"
                      style={{ left: 0, bottom: 0, width: '100%', height: '100%' }}
                    />
                    <Image
                      src={Orb}
                      alt="Orb"
                      className="position-absolute"
                      style={{
                        left: '50%',
                        transform: 'translateX(-50%)',
                        bottom: 8,
                        height: 130,
                        width: 130,
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} sm={6} lg={6}>
              <Card
                className="h-100 text-white"
                style={{
                  background: 'transparent',
                  borderRadius: 15,
                  overflow: 'hidden',
                  border: '1px solid transparent',
                  backgroundImage:
                    'linear-gradient(transparent, transparent), linear-gradient(180deg, rgba(255, 255, 255, 0.0576) 0%, rgba(255, 255, 255, 0.0512) 100%)',
                  backgroundOrigin: 'border-box',
                  backgroundClip: 'padding-box, border-box',
                  boxShadow: 'inset 0px 0px 8px 0px #FFFFFF0A',
                  paddingTop: 15,
                }}
              >
                <Card.Body className="d-flex flex-column" style={{ minHeight: 240, padding: 24 }}>
                  <div
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: 24,
                      lineHeight: '32px',
                      color: '#FFFFFF',
                      textAlign: 'left',
                    }}
                  >
                    Turn an AI prompt into a Viral ready-to-publish post
                  </div>
                  <div
                    style={{
                      marginTop: 12,
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: 16,
                      lineHeight: '24px',
                      color: '#FFFFFF6B',
                      maxWidth: 528,
                    }}
                  >
                    One AI prompt to create an SEO-optimized viral post in seconds. Cero unites them
                    with your background and expertise to craft personalized LinkedIn content.
                  </div>

                  <div
                    className="d-flex align-items-center justify-content-between flex-wrap gap-2 w-100"
                    style={{ marginTop: 60 }}
                  >
                    <Image
                      src={AIPrompt}
                      alt="AI Prompt"
                      className="img-fluid"
                      style={{ maxWidth: 400, height: 'auto' }}
                    />
                    <Image
                      src={Impressions}
                      alt="Impressions"
                      className="img-fluid"
                      style={{ maxWidth: 120, height: 'auto' }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <Card
                className="h-100 text-white"
                style={{
                  background: 'transparent',
                  borderRadius: 15,
                  overflow: 'hidden',
                  border: '1px solid transparent',
                  backgroundImage:
                    'linear-gradient(transparent, transparent), linear-gradient(180deg, rgba(255, 255, 255, 0.0576) 0%, rgba(255, 255, 255, 0.0512) 100%)',
                  backgroundOrigin: 'border-box',
                  backgroundClip: 'padding-box, border-box',
                  boxShadow: 'inset 0px 0px 8px 0px #FFFFFF0A',
                  paddingTop: 20,
                }}
              >
                <Card.Body
                  className="d-flex flex-column align-items-center"
                  style={{ minHeight: 240, padding: 16 }}
                >
                  <div
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: 24,
                      lineHeight: '32px',
                      color: '#FFFFFF',
                      textAlign: 'center',
                    }}
                  >
                    Never run out of content ideas
                  </div>
                  <div
                    style={{
                      marginTop: 8,
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: 16,
                      lineHeight: '24px',
                      color: '#FFFFFF6B',
                      textAlign: 'center',
                    }}
                  >
                    Choose from top inspiration in your industry and niche.
                  </div>
                  <Image
                    src={HotTake}
                    alt="Hot take"
                    style={{ width: '100%', height: 'auto', marginTop: 80 }}
                  />
                  <div
                    className="w-100"
                    style={{
                      backgroundColor: '#000',
                      borderRadius: 8,
                      marginTop: 20,
                      position: 'relative',
                      height: 80,
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        top: 15.4,
                        left: 16.8,
                        fontFamily: 'SF Pro Display, -apple-system, system-ui, Inter, sans-serif',
                        fontWeight: 500,
                        fontSize: 9.8,
                        lineHeight: '100%',
                        color: '#FFFFFFE0',
                      }}
                    >
                      Technology / Hot Take
                    </div>
                    <div
                      style={{
                        position: 'absolute',
                        top: 48,
                        left: 16,
                        right: 16,
                        fontFamily: 'SF Pro Display, -apple-system, system-ui, Inter, sans-serif',
                        fontWeight: 100,
                        fontSize: 13.4,
                        lineHeight: '22.4px',
                        color: '#FFFFFFE0',
                        opacity: 0.5,
                      }}
                    >
                      Looking back at the last years, how
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="w-100 justify-content-center g-2" style={{ marginTop: 8 }}>
            <Col xs={12} sm={6} lg={6}>
              <Card
                className="h-100 text-white"
                style={{
                  background: 'transparent',
                  borderRadius: 15,
                  overflow: 'hidden',
                  border: '1px solid transparent',
                  backgroundImage:
                    'linear-gradient(transparent, transparent), linear-gradient(180deg, rgba(255, 255, 255, 0.0576) 0%, rgba(255, 255, 255, 0.0512) 100%)',
                  backgroundOrigin: 'border-box',
                  backgroundClip: 'padding-box, border-box',
                  boxShadow: 'inset 0px 0px 8px 0px #FFFFFF0A',
                  paddingTop: 24,
                }}
              >
                <Card.Body className="d-flex flex-column" style={{ padding: 16 }}>
                  <div
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: 24,
                      lineHeight: '32px',
                      letterSpacing: '0%',
                      color: '#FFFFFF',
                      textAlign: 'left',
                      paddingLeft: 24,
                    }}
                  >
                    Grow faster with data-driven analytics
                  </div>

                  <div
                    style={{
                      marginTop: 6,
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: 16,
                      lineHeight: '24px',
                      letterSpacing: '0%',
                      color: '#FFFFFF6B',
                      textAlign: 'left',
                      paddingLeft: 24,
                    }}
                  >
                    Cero tracks your performance to optimize your strategy and posts. With every
                    post you make it get better.
                  </div>

                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex" style={{ gap: 16, paddingLeft: 24 }}>
                      <div className="d-flex flex-column">
                        <span
                          style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 400,
                            fontSize: 20,
                            lineHeight: '32px',
                            letterSpacing: '0%',
                            color: '#FFFFFF',
                          }}
                        >
                          +1208
                        </span>
                        <span
                          style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 400,
                            fontSize: 14,
                            lineHeight: '24px',
                            letterSpacing: '0%',
                            color: '#FFFFFF6B',
                          }}
                        >
                          Gained Followers
                        </span>
                      </div>
                      <div className="d-flex flex-column">
                        <span
                          style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 400,
                            fontSize: 20,
                            lineHeight: '32px',
                            letterSpacing: '0%',
                            color: '#FFFFFF',
                          }}
                        >
                          +22
                        </span>
                        <span
                          style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 400,
                            fontSize: 14,
                            lineHeight: '24px',
                            letterSpacing: '0%',
                            color: '#FFFFFF6B',
                          }}
                        >
                          Potential Leads
                        </span>
                      </div>
                    </div>
                    <Image src={LegendGraphLeads} alt="Legend" height={150} width={150} />
                  </div>

                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ marginTop: 8 }}
                  >
                    <Image
                      src={GraphLeads}
                      alt="Leads graph"
                      className="img-fluid"
                      style={{ maxWidth: '100%' }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} sm={6} lg={6}>
              <Card
                className="h-100 text-white"
                style={{
                  background: 'transparent',
                  borderRadius: 15,
                  overflow: 'hidden',
                  border: '1px solid transparent',
                  backgroundImage:
                    'linear-gradient(transparent, transparent), linear-gradient(180deg, rgba(255, 255, 255, 0.0576) 0%, rgba(255, 255, 255, 0.0512) 100%)',
                  backgroundOrigin: 'border-box',
                  backgroundClip: 'padding-box, border-box',
                  boxShadow: 'inset 0px 0px 8px 0px #FFFFFF0A',
                  paddingTop: 24,
                }}
              >
                <Card.Body className="d-flex flex-column h-100">
                  <div
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: 24,
                      lineHeight: '32px',
                      letterSpacing: '0%',
                      color: '#FFFFFF',
                      textAlign: 'left',
                      paddingLeft: 24,
                    }}
                  >
                    Top-notch graphic templates
                  </div>

                  <div
                    style={{
                      marginTop: 6,
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: 16,
                      lineHeight: '24px',
                      letterSpacing: '0%',
                      color: '#FFFFFF6B',
                      textAlign: 'left',
                      paddingLeft: 24,
                    }}
                  >
                    Graphics are the key craft, and good ones lift your content creation to new
                    heights for better authenticity.
                  </div>

                  <div className="d-flex align-items-center justify-content-center mt-auto">
                    <Image
                      src={GraphicTemplate}
                      alt="Graphic template"
                      className="img-fluid"
                      style={{ maxWidth: '100%', paddingLeft: 24 }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="w-100 justify-content-center g-2" style={{ marginTop: 8 }}>
            <Col xs={12} sm={6} lg={4}>
              <Card
                className="h-100 text-white"
                style={{
                  background: 'transparent',
                  borderRadius: 15,
                  overflow: 'hidden',
                  border: '1px solid transparent',
                  backgroundImage:
                    'linear-gradient(transparent, transparent), linear-gradient(180deg, rgba(255, 255, 255, 0.0576) 0%, rgba(255, 255, 255, 0.0512) 100%)',
                  backgroundOrigin: 'border-box',
                  backgroundClip: 'padding-box, border-box',
                  boxShadow: 'inset 0px 0px 8px 0px #FFFFFF0A',
                  paddingTop: 24,
                }}
              >
                <Card.Body
                  className="d-flex flex-column align-items-center justify-content-between"
                  style={{ minHeight: 260, paddingBottom: 24 }}
                >
                  <div className="d-flex flex-column align-items-center" style={{ width: '100%' }}>
                    <div
                      style={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 500,
                        fontSize: 24,
                        lineHeight: '32px',
                        textAlign: 'center' as const,
                        color: '#FFFFFF',
                        width: '80%',
                      }}
                    >
                      Simple scheduling
                      <br />
                      with smart calendar
                    </div>
                    <div
                      style={{
                        marginTop: 12,
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: '24px',
                        textAlign: 'center' as const,
                        color: '#FFFFFF6B',
                        width: '100%',
                        marginBottom: 80,
                      }}
                    >
                      Schedule, and optimize content distribution through an AI-built content
                      calendar.
                    </div>
                  </div>

                  <div className="position-relative w-100" style={{ height: 140 }}>
                    <Image
                      src={Union}
                      alt="Union"
                      className="position-absolute"
                      style={{ left: 0, bottom: 0, width: '100%', height: '100%' }}
                    />
                    <Image
                      src={Orb}
                      alt="Orb"
                      className="position-absolute"
                      style={{
                        left: '50%',
                        transform: 'translateX(-50%)',
                        bottom: 8,
                        height: 130,
                        width: 130,
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} sm={6} lg={4}>
              <Card
                className="h-100 text-white"
                style={{
                  background: 'transparent',
                  borderRadius: 15,
                  overflow: 'hidden',
                  border: '1px solid transparent',
                  backgroundImage:
                    'linear-gradient(transparent, transparent), linear-gradient(180deg, rgba(255, 255, 255, 0.0576) 0%, rgba(255, 255, 255, 0.0512) 100%)',
                  backgroundOrigin: 'border-box',
                  backgroundClip: 'padding-box, border-box',
                  boxShadow: 'inset 0px 0px 8px 0px #FFFFFF0A',
                  paddingTop: 24,
                }}
              >
                <Card.Body
                  className="d-flex flex-column align-items-center"
                  style={{ minHeight: 240, paddingBottom: 24 }}
                >
                  <div className="d-flex flex-column align-items-center" style={{ width: '100%' }}>
                    <div
                      style={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 500,
                        fontSize: 24,
                        lineHeight: '32px',
                        textAlign: 'center' as const,
                        color: '#FFFFFF',
                        width: '80%',
                      }}
                    >
                      Productive AI-powered
                      <br />
                      engagements
                    </div>
                    <div
                      style={{
                        marginTop: 12,
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: '24px',
                        textAlign: 'center' as const,
                        color: '#FFFFFF6B',
                        width: '100%',
                      }}
                    >
                      Engage with influential voices in your niche to grow your network - fast and
                      effortlessly.
                    </div>
                  </div>

                  <div
                    className="d-flex flex-column align-items-center w-100 mt-auto"
                    style={{ gap: 20 }}
                  >
                    <Image src={PromptBox} alt="Prompt box" />
                    <Image src={FeatureItem} alt="Feature item" />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} sm={6} lg={4}>
              <Card
                className="h-100 text-white"
                style={{
                  background: 'transparent',
                  borderRadius: 15,
                  overflow: 'hidden',
                  border: '1px solid transparent',
                  backgroundImage:
                    'linear-gradient(transparent, transparent), linear-gradient(180deg, rgba(255, 255, 255, 0.0576) 0%, rgba(255, 255, 255, 0.0512) 100%)',
                  backgroundOrigin: 'border-box',
                  backgroundClip: 'padding-box, border-box',
                  boxShadow: 'inset 0px 0px 8px 0px #FFFFFF0A',
                  paddingTop: 24,
                }}
              >
                <Card.Body
                  className="d-flex flex-column align-items-center"
                  style={{ minHeight: 240, paddingBottom: 24 }}
                >
                  <div className="d-flex flex-column align-items-center" style={{ width: '100%' }}>
                    <div
                      style={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 500,
                        fontSize: 24,
                        lineHeight: '32px',
                        textAlign: 'center' as const,
                        color: '#FFFFFF',
                        width: '80%',
                        paddingLeft: 24,
                      }}
                    >
                      Smooth collaboration
                      <br />
                      with your team
                    </div>
                    <div
                      style={{
                        marginTop: 12,
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 400,
                        fontSize: 16,
                        lineHeight: '24px',
                        textAlign: 'center' as const,
                        color: '#FFFFFF6B',
                        width: '100%',
                        paddingLeft: 24,
                      }}
                    >
                      Edit, refine and co-create content with your team in real-time.
                    </div>
                  </div>

                  <div className="d-flex align-items-center justify-content-center mt-auto">
                    <Image
                      src={ProfileContainerFidget}
                      alt="Team collaboration"
                      className="img-fluid"
                      style={{ maxWidth: '95%' }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};
